import React, { useEffect } from "react";

function Toolbar({ onAction, goBack, goHome, currentPath }) {
  const roleId = localStorage.getItem("roleId");
  const roleNumber = parseInt(roleId); // Convert "3" → 3, "2" → 2

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  // Future-proof permissions config by role ID numbers
  const permissions = {
    // Role ID 3 = Center User: view + download only
    3: {
      navigation: true, // Home, Back
      create: false,
      upload: false,
      preview: true,
      copy: false,
      move: false,
      rename: false,
      download: true,
      delete: false,
    },
    // Role ID 2 = Organization: full access
    2: {
      navigation: true,
      create: true,
      upload: true,
      preview: true,
      copy: true,
      move: true,
      rename: true,
      download: true,
      delete: true,
    },
    2: {
      navigation: true,
      create: true,
      upload: true,
      preview: true,
      copy: true,
      move: true,
      rename: true,
      download: true,
      delete: true,
    },
    2034: {
      navigation: true,
      create: true,
      upload: true,
      preview: true,
      copy: true,
      move: true,
      rename: true,
      download: true,
      delete: true,
    },

    // Role ID 1 = Super Admin: full access
    1: {
      navigation: true,
      create: true,
      upload: true,
      preview: true,
      copy: true,
      move: true,
      rename: true,
      download: true,
      delete: true,
    },
    // Role ID 4 = Viewer: read-only
    4: {
      navigation: true,
      create: false,
      upload: false,
      preview: true,
      copy: false,
      move: false,
      rename: false,
      download: false,
      delete: false,
    },
    // Default: minimal access (fallback)
    default: {
      navigation: true,
      create: false,
      upload: false,
      preview: true,
      copy: false,
      move: false,
      rename: false,
      download: false,
      delete: false,
    },
  };

  // Get current user's permissions
  const userPermissions = permissions[roleNumber] || permissions.default;

  return (
    <div className="toolbar gap-2">
      {/* Navigation - always visible */}
      {userPermissions.navigation && (
        <div className="d-flex gap-1">
          <button
            className="btn btn-primary p-0 lh-1 m-0"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Home"
            onClick={goHome}
            style={{ width: "25px", height: "25px" }}
          >
            <i className="fas fa-home lh-1 m-0"></i>
          </button>
          {currentPath !== "\\" && (
            <button
              className="btn btn-outline-primary p-0 lh-1 m-0"
              data-bs-toggle="tooltip"
              data-bs-custom-class="custom-tooltip"
              title="Back"
              onClick={goBack}
              style={{ width: "25px", height: "25px" }}
            >
              <i className="fas fa-arrow-left lh-1 m-0"></i>
            </button>
          )}
        </div>
      )}

      {/* Create/Upload Section - Organization (2) only */}
      {(userPermissions.create || userPermissions.upload) && (
        <div className="d-flex gap-2">
          {userPermissions.create && (
            <button
              className="btn btn-outline-primary px-2 py-1"
              onClick={() => onAction("create")}
            >
              <i className="fas fa-plus me-1"></i>
              Create
            </button>
          )}
          {userPermissions.upload && (
            <button
              className="btn btn-outline-primary px-2 py-1"
              onClick={() => onAction("upload")}
            >
              <i className="fas fa-upload me-1"></i>
              Upload
            </button>
          )}
        </div>
      )}

      {/* Actions Bar */}
      <div className="d-flex ms-auto actions-bar">
        {userPermissions.preview && (
          <div
            className="tool-btn"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Preview"
            onClick={() => onAction("preview")}
          >
            <i className="fas fa-eye"></i>
          </div>
        )}

        {userPermissions.copy && (
          <div
            className="tool-btn"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Copy"
            onClick={() => onAction("copy")}
          >
            <i className="fas fa-copy"></i>
          </div>
        )}

        {userPermissions.move && (
          <div
            className="tool-btn"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Move"
            onClick={() => onAction("move")}
          >
            <i className="fas fa-shuffle"></i>
          </div>
        )}

        {userPermissions.rename && (
          <div
            className="tool-btn"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Rename"
            onClick={() => onAction("rename")}
          >
            <i className="fas fa-edit"></i>
          </div>
        )}

        {userPermissions.download && (
          <div
            className="tool-btn"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Download"
            onClick={() => onAction("download")}
          >
            <i className="fas fa-download"></i>
          </div>
        )}

        {userPermissions.delete && (
          <div
            className="tool-btn"
            data-bs-toggle="tooltip"
            data-bs-custom-class="custom-tooltip"
            title="Delete"
            onClick={() => onAction("delete")}
          >
            <i className="fas fa-trash-can"></i>
          </div>
        )}
      </div>
    </div>
  );
}

export default Toolbar;
